// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2hdpL","footer":"ModalError_footer__nEeD9"};